import {CheckCircle2, Circle, ListTodo, Pin} from "lucide-react";

import {Badge} from "@/components/ui/badge";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "@/components/ui/card";
import {cn} from "@/lib/utils";

// Sort tasks: pinned first, then by completion status
const sortedTasks = [
  {id: "1", title: "Complete shift handover notes", pinned: true, completed: false},
  {
    id: "2",
    title: "Review security protocols for Downtown Plaza",
    pinned: true,
    completed: false,
  },
  {id: "3", title: "Submit weekly incident summary", pinned: false, completed: false},
  {id: "4", title: "Update emergency contact information", pinned: false, completed: false},
  {id: "5", title: "Review patrol route changes", pinned: false, completed: false},
].sort((a, b) => {
  if (a.pinned && !b.pinned) return -1;
  if (!a.pinned && b.pinned) return 1;
  if (a.completed && !b.completed) return 1;
  if (!a.completed && b.completed) return -1;
  return 0;
});

// interface Passdowns {
//   passdowns
// }

export function Passdowns() {
  const pass = [];

  return (
    <Card className={cn("h-full", !pass.length && "shadow-none border-2 border-dashed")}>
      <CardHeader>
        <CardTitle>Tasks</CardTitle>
        <CardDescription>Your pending tasks and reminders</CardDescription>
      </CardHeader>
      <CardContent>
        {pass.length > 0 ? (
          <div className="space-y-2">
            {sortedTasks.map((task) => (
              <div
                key={task.id}
                className={`flex items-center gap-3 p-3 rounded-lg border transition-colors ${
                  task.completed ? "bg-muted/50 opacity-60" : "hover:bg-accent"
                }`}
              >
                <p
                  className={`flex-1 text-sm ${task.completed ? "line-through text-muted-foreground" : "text-foreground"}`}
                >
                  {task.title}
                </p>
                {task.pinned ? (
                  <Pin className="h-4 w-4 text-primary flex-shrink-0" />
                ) : (
                  <button
                    // onClick={() => handleToggleTask(task.id)}
                    className="flex-shrink-0 hover:opacity-70 transition-opacity"
                  >
                    {task.completed ? (
                      <CheckCircle2 className="h-5 w-5 text-primary" />
                    ) : (
                      <Circle className="h-5 w-5 text-muted-foreground" />
                    )}
                  </button>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="rounded-full bg-muted p-4 mb-3">
              <ListTodo className="h-8 w-8 text-muted-foreground" />
            </div>
            <h3 className="text-lg font-semibold mb-1">No Tasks</h3>
            <p className="text-sm text-muted-foreground max-w-sm">
              You're all caught up! No pending tasks at the moment.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
